import { sanitizeRedirect } from "./redirect";
import type { LogoutReason } from "./store";

export interface LoginSearch {
  reason?: LogoutReason;
  /** IR-1288 — internal path to restore after a successful re-login. */
  redirect?: string;
}

// IR-1241: /login?reason=<...> lets the SessionController tell the login screen
// why the operator landed here, so we can show the right banner.
// IR-1288: /login?redirect=<path> carries the page they were on so the re-login
// puts them back there. It arrives from the URL, i.e. it is user-controllable,
// so it is sanitised here on the way in as well as at the producers.
export function validateLoginSearch(search: Record<string, unknown>): LoginSearch {
  const out: LoginSearch = {};

  const r = search.reason;
  if (r === "expired" || r === "idle" || r === "manual") out.reason = r;

  const back = sanitizeRedirect(search.redirect);
  if (back) out.redirect = back;

  return out;
}

// A deliberate sign-out ("manual") shows no banner — the operator knows why they
// left. Only involuntary logouts explain themselves.
export function loginReasonMessage(reason: LogoutReason | undefined): string | null {
  switch (reason) {
    case "idle":
      return "You were signed out due to inactivity. Please sign in again.";
    case "expired":
      return "Your session ended. Please sign in again.";
    default:
      return null;
  }
}
